import { combine, withCallbacks } from 'react-hooks-combine'

import DateInputComponent from './component'

export default combine({
  hooks: [
    withCallbacks(
      {
        onInternalChange:
          (_state, { onChange, onBlur }) =>
          (value) => {
            onChange({ target: { value } })
            onBlur()
          },
      },
      []
    ),
  ],

  transformProps: (props) => ({
    ...props,
    selectedDate: props.value,
  }),
})(DateInputComponent)
